// extracted by mini-css-extract-plugin
export default {"signing-content-wrapper":"TxhYY8Ik","signingContentWrapper":"TxhYY8Ik"};